export const USER_ROLE = {
    CLIENT: "client",
    ADMIN: "admin",
    ORGANIZER: "organizer",
    LOGISTICIAN: "logistician",
    MERCHANDISER: "merchandiser",
    STOREKEEPER: "storekeeper",
};
export const POSITION_LIST = [
    { label: "Организатор", value: USER_ROLE.ORGANIZER },
    { label: "Логист", value: USER_ROLE.LOGISTICIAN },
    { label: "Мерчендайзер", value: USER_ROLE.MERCHANDISER },
    { label: "Сотрудник склада", value: USER_ROLE.STOREKEEPER },
];
